var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrust(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87:863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.1147 12.3591C44.0901 11.0632 44.0665 9.83894 44.0665 8.65457C44.0665 7.72669 43.3145 6.97444 42.3864 6.97444C35.2011 6.97444 29.7304 4.90946 25.1703 0.475727C24.518 -0.158688 23.4799 -0.158464 22.8278 0.475727C18.2681 4.90946 12.7983 6.97444 5.61345 6.97444C4.68557 6.97444 3.93332 7.72669 3.93332 8.65457C3.93332 9.83917 3.91003 11.0639 3.88516 12.36C3.65487 24.4202 3.33946 40.9371 23.4487 47.9074C23.6271 47.9692 23.813 48.0001 23.9989 48.0001C24.1849 48.0001 24.371 47.9692 24.5491 47.9074C44.66 40.9369 44.345 24.4195 44.1147 12.3591ZM23.9991 44.5371C6.75279 38.272 7.01355 24.5476 7.24496 12.4241C7.25885 11.6965 7.27229 10.9913 7.2817 10.3C14.0112 10.0159 19.3925 7.97669 23.9991 3.96366C28.6063 7.97669 33.9885 10.0161 40.7184 10.3C40.7278 10.9911 40.7412 11.6958 40.7551 12.423C40.9863 24.547 41.2468 38.2718 23.9991 44.5371Z",
    fill: "#3C4564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7847 18.1639L21.6756 26.2726L18.2152 22.8122C17.559 22.1563 16.4952 22.1563 15.8393 22.8122C15.1831 23.4686 15.1831 24.5322 15.8393 25.1884L20.4876 29.8367C20.8156 30.1647 21.2457 30.3286 21.6756 30.3286C22.1055 30.3286 22.5356 30.1647 22.8635 29.8367L32.1604 20.54C32.8168 19.8839 32.8168 18.82 32.1607 18.1641C31.5047 17.508 30.4409 17.5077 29.7847 18.1639Z",
    fill: "#3C4564"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87:863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrust);
export default __webpack_public_path__ + "static/media/Trust.57b0a238.svg";
export { ForwardRef as ReactComponent };